import { Deserializable } from '../deserializable';
import {PermissionCode} from './permissioncode';


export  class Permission implements Deserializable
{
  public id: number;
  public funcName: string;
  public funcDescription: string;
  public permissionCodeList: PermissionCode[];
  deserialize(input: any): this {
    Object.assign(this, input);
    this.permissionCodeList = input.permissionCodeList.map(data=> new PermissionCode().deserialize(data));
    return this;
  }
}
